import React from "react";

export interface ProjectCardProps {
  title: string;
  category: string;
  description: string;
  techStack: string[];
  url: string;
  github: string;
  pmInsight: string;
}

const ProjectCard = (props: ProjectCardProps): React.ReactNode => {
  return (
    <div className="rounded-xl border border-card-border bg-card-bg p-5 hover:border-accent/30 transition-all group flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold tracking-wider uppercase text-accent">
          {props.category}
        </span>
        <div className="flex gap-1">
          {props.github && (
            <a
              href={props.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted hover:text-primary transition-colors p-1.5"
              aria-label="View source code"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
            </a>
          )}
          {props.url && props.url !== props.github && (
            <a
              href={props.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted hover:text-primary transition-colors p-1.5"
              aria-label="View live demo"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" />
              </svg>
            </a>
          )}
        </div>
      </div>

      <h3 className="text-primary font-bold text-lg mb-2 group-hover:text-accent transition-colors">
        {props.title}
      </h3>

      <p className="text-muted text-sm leading-relaxed mb-4 flex-grow">
        {props.description}
      </p>

      <div className="flex flex-wrap gap-2 mt-auto">
        {props.techStack.map((tech) => (
          <span
            key={tech}
            className="text-xs px-2 py-0.5 rounded border border-card-border text-muted"
          >
            {tech}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ProjectCard;
